import { type ReactNode } from 'react';
import { ThumbsDown, ThumbsUp, Check, Trophy } from 'lucide-react';

type Tier = { icon: ReactNode; color: string };

export function dailyTier(count: number): Tier {
  if (count >= 99) return { icon: <Trophy size={14} />, color: 'text-warning' };
  if (count >= 66) return { icon: <Check size={14} />, color: 'text-success' };
  if (count >= 33) {
    return { icon: <ThumbsUp size={14} />, color: 'text-text-tertiary' };
  }
  return { icon: <ThumbsDown size={14} />, color: 'text-error' };
}
